var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27.0 27.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1600,0 L1600,1080 L0,1080 L0,0 L1600,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,13.8425 L24.5,25.375 C24.5,25.85625 24.10625,26.25 23.625,26.25 L2.625,26.25 C2.14375,26.25 1.75,25.85625 1.75,25.375 L1.75,13.8425 C2.0213,13.93859 2.31875,13.99992 2.625,13.99992 C2.93125,13.99992 3.22871,13.93879 3.5,13.8425 L3.5,24.5 L5.25,24.5 L5.25,16.625 C5.25,16.14375 5.64375,15.75 6.125,15.75 L11.375,15.75 C11.85625,15.75 12.25,16.14375 12.25,16.625 L12.25,24.5 L22.75,24.5 L22.75,13.8425 C23.0213,13.93859 23.31875,13.99992 23.625,13.99992 C23.93125,13.99992 24.22871,13.93879 24.5,13.8425 Z M20.125,14.875 C20.608205,14.875 21,15.358205 21,15.75 L21,21 C21,21.483205 20.608205,21.875 20.125,21.875 L14.875,21.875 C14.391795,21.875 14,21.391795 14,21 L14,15.75 C14,15.266795 14.391795,14.875 14.875,14.875 L20.125,14.875 Z M25.375,7 C25.85625,7 26.25,7.39375 26.25,7.875 L26.25,9.625 C26.25,11.06875 25.06875,12.25 23.625,12.25 C22.95115,12.25 22.33867,11.98752 21.875,11.5676 C21.41135,11.9875 20.79885,12.25 20.125,12.25 C19.45115,12.25 18.83867,11.98752 18.375,11.5676 C17.91135,11.9875 17.29885,12.25 16.625,12.25 C15.95115,12.25 15.33867,11.98752 14.875,11.5676 C14.41135,11.9875 13.79885,12.25 13.125,12.25 C12.45115,12.25 11.83867,11.98752 11.375,11.5676 C10.91135,11.9875 10.29885,12.25 9.625,12.25 C8.95115,12.25 8.33867,11.98752 7.875,11.5676 C7.41135,11.9875 6.79885,12.25 6.125,12.25 C5.45115,12.25 4.83867,11.98752 4.375,11.5676 C3.91135,11.9875 3.29885,12.25 2.625,12.25 C1.18125,12.25 0,11.06875 0,9.625 L0,7.875 C0,7.39375 0.39375,7 0.875,7 Z M22.75015,0 C23.15271,0 23.50271,0.2713 23.599,0.66505 L24.745,5.25 L1.505,5.25 L2.6513,0.66505 C2.7476,0.27129 3.09761,0 3.50015,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164.0 -602.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.0 205.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 367.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.0 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 25.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.375 4.375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.25,0 26.25,26.25 0,26.25 0,0",
    stroke: "none",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-45.20833333333333 -4.375)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 116.666667,0 116.666667,116.666667 0,116.666667 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.1208e080b5b28f85050fd2cf521188ba.svg";
export { ForwardRef as ReactComponent };